import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { css } from 'emotion';
import Slider from 'react-slick';
import withMedia from '~/modules/core/utils/mediaHelpers/withMedia';
import withDirection from '~/modules/core/utils/mediaHelpers/withDirection';
import { cssMediaMax } from '~/modules/core/utils/cssHelpers/cssMedia';

const MainSliderStyle = styled(Slider)`
  /* stylelint-disable */
  && { height: 400px; }
  ${cssMediaMax.tablet`
      && { height: 350px; }
  `};
  .slick-dots {
    ${props => props.media.tablet && css`
       bottom: 0;
  `};
  }
  .slick-list, .slick-slide, .slick-track,
  .slick-slide > div {
    height: 100%;
  }
  .slick-slide {
    float: left !important;
    > div {
      > div {
        border-style: none;
        border-color: ${props => props.theme.borders.color.normal};
        outline: none;
        ${cssMediaMax.tablet`
          border: 1px solid #e6e6e6;
        `};

        ${props => props.media.minDesktop
          && css`
            border-width: ${props.theme.borders.size.thin}px;
            border-style: solid;
          `};
      }
    }
  }
  .slick-prev:before {
      content: '\\e802';
      font-family: fontello, sans-serif;
    }
    .slick-next:before {
      content: '\\e801';
      font-family: fontello, sans-serif;
    }
    .slick-prev {
      padding-right: 3px;
      left: 15px;
      :before {
        content: '\\e802';
        font-family: fontello, sans-serif;
      }
    }
    .slick-next {
      padding-left: 3px;
      right: 15px;
      left: auto;
      :before {
        content: '\\e801';
        font-family: fontello, sans-serif;
      }
    }
    .slick-prev,
    .slick-next {
      width: 32px;
      height: 80px;
      text-align: center;
      border-radius: 5px;
      display: inline-block;
      color: #7f7f7f;
      background-color: ${props => props.theme.colors.named.white};
      z-index: 2;
      top: 50%;
      box-shadow: 0px 1px 5px 0 rgba(0, 0, 0, 0.1);
      &:before {
        font-size: 47px;
        color: ${props => props.theme.colors.labels.important};
        opacity: 0.7;
      }
      &:hover:before {
        color: ${props => props.theme.colors.secondary};
      }
      opacity: 0.9;
    }
    .slick-disabled {
      color: ${props => props.theme.colors.labels.important};
      opacity: 0.5;
      cursor: not-allowed;
      &:hover:before {
        color: ${props => props.theme.colors.labels.important};
        opacity: 0.3;
      }
    }
`;

const MainSlider = ({
  innerRef,
  media,
  afterChange,
  children,
}) => (
  <MainSliderStyle
    infinite
    innerRef={innerRef}
    dots={!media.minDesktop}
    arrows={media.minDesktop}
    media={media}
    afterChange={afterChange}
    rtl={false}
  >
    {children}
  </MainSliderStyle>
);

MainSlider.propTypes = {
  afterChange: PropTypes.func.isRequired,
  innerRef: PropTypes.func.isRequired,
  media: PropTypes.shape({}).isRequired,
  children: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default withDirection(withMedia(MainSlider));
